module.exports = __webpack_public_path__ + "static/media/about.64e6aa00.svg";